import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { ItalianForm } from 'shell/components/shared/sipo-person-form/new-person';
import { DateTime } from 'luxon';

interface ItalianComponentProps {
  disabled?: boolean;
  isEditMode?: boolean;
  values?: ItalianForm;
  errors?: FormikErrors<ItalianForm>;
  touched?: FormikTouched<ItalianForm>;
  onChange: (key: keyof ItalianForm, value: ItalianForm[keyof ItalianForm]) => void;
  labelMunicipality?: string;
  labelProvince?: string;
  eventDate?: DateTime | null;
}

const ItalianComponent = ({
  disabled,
  onChange,
  values,
  isEditMode,
  touched,
  errors,
  labelMunicipality = 'Comune di residenza',
  labelProvince = 'Provincia di residenza',
  eventDate,
}: ItalianComponentProps): React.ReactElement => {
  const handleMunicipalityListChange = useEventCallback(
    (municipality: MunicipalityAnprVM | null) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={4}>
        <MunicipalityList
          value={values?.municipality || null}
          onChange={handleMunicipalityListChange}
          required
          disabled={isEditMode ? false : disabled}
          label={labelMunicipality}
          fromDate={eventDate}
          error={
            // TODO: touched doesn't works
            (touched?.municipality as FormikTouched<MunicipalityAnprVM>) &&
            Boolean(errors?.municipality as FormikErrors<MunicipalityAnprVM>)
          }
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label={labelProvince}
          label={labelProvince}
          id="province"
          name="province"
          fullWidth
          disabled
          type="text"
          variant="outlined"
          value={values?.municipality?.province || ''}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locality"
          name="locality"
          fullWidth
          disabled={isEditMode ? false : disabled}
          type="text"
          variant="outlined"
          value={values?.location || ''}
          onChange={(event) => {
            onChange('location', event.target.value);
          }}
          inputProps={{
            maxLength: '120',
          }}
        />
      </Grid>
    </Grid>
  );
};

ItalianComponent.displayName = 'Italian generality component';

const Italian = memo(ItalianComponent);

export default Italian;
